module.exports = __webpack_public_path__ + "img/ic-word-of-mouth.a439123d.svg";